import { SxProps, Theme } from '@mui/material';

export const stylesFormalitiesFormErrorIcon: SxProps<Theme> = {
  fontSize: 'bodyLG.fontSize',
};
